import { render, staticRenderFns } from "./BizUnitTable.vue?vue&type=template&id=39a95cce&scoped=true"
import script from "./BizUnitTable.vue?vue&type=script&lang=js"
export * from "./BizUnitTable.vue?vue&type=script&lang=js"
import style0 from "./BizUnitTable.vue?vue&type=style&index=0&id=39a95cce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a95cce",
  null
  
)

export default component.exports